import React, { useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Link from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";
import Box from "@mui/material/Box";
import toast from "react-simple-toasts";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import FormPaper from "../FormPaper";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

function Login({ user }) {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const email = event.target.email.value;
    const password = event.target.password.value;

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/accounts/login`,
      {
        email,
        password,
      },
    );

    // Navigate to the home page if the connection succeeded
    if (res.data.success) {
      toast(res.data.message, { theme: "success" });
      await refreshUser();
      navigate("/");
    } else {
      toast(res.data.message, { theme: "failure" });
    }
  };

  return (
    <FormPaper>
      <form id="login" onSubmit={handleSubmit}>
        <Stack spacing={2} direction={"column"}>
          <Typography variant="h4">Connexion</Typography>
          <TextField id="email" label="Courriel" type="email" required />
          <TextField
            id="password"
            label="Mot de passe"
            type={showPassword ? "text" : "password"}
            required
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={
                        showPassword
                          ? "Masquer le mot de passe"
                          : "Afficher le mot de passe"
                      }
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
          />
          <Button
            form="login"
            variant="contained"
            color="primary"
            type="submit"
            disabled={!!user}
          >
            Connexion
          </Button>
          {user ? (
            <Box sx={{ width: "auto" }}>
              <Typography variant="body2">Vous êtes déjà connecté</Typography>
              <Link
                component={RouterLink}
                to="/compte/deconnexion"
                underline="hover"
              >
                Déconnexion
              </Link>
            </Box>
          ) : (
            <Box>
              <Typography variant="body2">
                Vous n'avez pas de compte?
              </Typography>
              <Link
                component={RouterLink}
                to="/compte/creer-compte"
                underline="hover"
              >
                Créer un compte
              </Link>
            </Box>
          )}
        </Stack>
      </form>
    </FormPaper>
  );
}

export default Login;
